import styled from '@emotion/styled';
import { COLOR } from './styles';

export const Wrapper = styled.div`
  height: 100%;
  background-color: ${COLOR.background.base};
  padding: 64px 24px;
`;
